import { QUERY_KEYS } from 'api/query-keys';
import { useQuery } from 'react-query';
import { CACHE_TIME_LONG } from 'shared/react-query/query-defaults';
import { dashboardService } from 'api/services';
import { Site } from 'shared/hooks';
import {
  Interval,
  ShiftOverviewChartResponse,
} from 'api/services/dashboard/dashboard-service.schema';

export const useGetDashboardCharts = (
  site: Site,
  startDate: string,
  endDate: string,
  groupBy: Interval
) => {
  const queryFn = async () =>
    await dashboardService.getShiftOverviewChart(site, startDate, endDate, groupBy);

  return useQuery<Promise<ShiftOverviewChartResponse>, Error, ShiftOverviewChartResponse>(
    QUERY_KEYS.dashboardChart(),
    queryFn,
    {
      cacheTime: CACHE_TIME_LONG,
    }
  );
};
